<template>
  <div
    id="app"
    style="
      margin: auto;
      box-shadow: 0px 0px 20px #888888;
      background: #f2f2f2;
      min-height: 100vh;
    "
  >
    <el-alert
      title="Mobile support limited, please use desktop for best experience."
      type="danger"
      class="hidden-sm hidden-md hidden-lg"
      center
      :closable="false"
      style="padding-left: 30px; color: red; font-size: 10px; background: #ccc"
    >
    </el-alert>
    <AdminAlerts />
    <router-view />
  </div>
</template>
<script>
import AdminAlerts from "@/components/AdminAlerts.vue";
export default {
  name: "app",
  components: {
    AdminAlerts,
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  background: #e4e4e4;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
